.flyout {
  border-radius: 10px;
  background: var(--static-background-strong);
  border: 1px solid var(--static-divider-standard);
  display: flex;
  flex-direction: column;
  overflow: hidden auto;
  box-shadow: var(--box-shadow);
}
.option {
  padding: 8px 12px;
  cursor: pointer;
  display: flex;
  gap: 8px;
  align-items: center;
}
.option:hover {
  background: var(--static-background-weak);
}

@keyframes show {
  0% {
    opacity: 0;
    transform: translateY(-10px);
  }
  100% {
    opacity: 1;
    transform: none;
  }
}

@keyframes hide {
  0% {
    opacity: 1;
    transform: none;
  }
  100% {
    opacity: 0;
    transform: translateY(-10px);
  }
}

.flyout.visible {
  animation: show 100ms ease forwards;
}
.flyout.closing {
  animation: hide 100ms ease forwards;
}
